import { ActionBase } from '../../../core/store/action/ActionBase';

export const GET_CURRENT_USER_SUBMITTING_ENTITIES = '[Security] Get Current User Submitting Entities';

export class GetCurrentUserSubmittingEntitiesAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_CURRENT_USER_SUBMITTING_ENTITIES;
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/GetCurrentUserSubmittingEntitiesAction.ts